import { Reveal } from "@/components/Reveal";

const panels = [
  {
    n: "01",
    title: "Brand Development",
    body: "Names, positioning, and identities that give your brand a clear foundation.",
    bg: "#1C0729", // deep midnight plum
    heading: "#f6f0e6",
    text: "rgba(233, 223, 240, 0.75)",
    number: "rgba(246, 240, 230, 0.28)",
    edgeOpacity: 0.9,
  },
  {
    n: "02",
    title: "Creative Direction",
    body: "A distinct vision carried through your imagery, campaigns, and entire brand world.",
    bg: "#EAC9CE", // soft blush pink
    heading: "#33122E",
    text: "rgba(51, 18, 46, 0.72)",
    number: "rgba(51, 18, 46, 0.22)",
    edgeOpacity: 0.75,
  },
  {
    n: "03",
    title: "Design & Digital",
    body: "Websites, print, content, and business materials that make every encounter feel connected.",
    bg: "#F3EDE3", // pearl
    heading: "#1c1a19",
    text: "rgba(28, 26, 25, 0.68)",
    number: "rgba(28, 26, 25, 0.18)",
    edgeOpacity: 0.75,
  },
];

const IRIDESCENT = "linear-gradient(100deg, #8fb3c4, #b3a3d4, #e3c2bd, #eed3ba, #9fc2d2, #c2b1dc)";

export const Expertise = () => (
  <section id="expertise" data-testid="expertise-section" className="px-6 md:px-12 lg:px-24 py-24 md:py-36">
    <Reveal>
      <p className="text-[11px] uppercase tracking-[0.34em] text-charcoal-mute mb-6">What I Do</p>
      <h2 className="font-serif text-4xl md:text-6xl tracking-tight leading-[1.02] max-w-3xl mb-14 md:mb-20">
        Three disciplines, <span className="italic">one point of view.</span>
      </h2>
    </Reveal>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 lg:gap-6 items-stretch">
      {panels.map((p, i) => (
        <Reveal key={p.n} delay={i * 0.08} className="h-full">
          <article
            data-testid={`expertise-panel-${p.n}`}
            className="group relative h-full overflow-hidden flex flex-col p-7 md:p-8 lg:p-10 transition-transform duration-500 hover:-translate-y-1"
            style={{ background: p.bg }}
          >
            {/* iridescent top edge */}
            <span
              aria-hidden="true"
              className="absolute top-0 left-0 right-0 h-[3px] opacity-70 group-hover:opacity-100 transition-opacity duration-500"
              style={{ background: IRIDESCENT, backgroundSize: "200% auto", opacity: p.edgeOpacity * 0.8 }}
            />
            <div>
              <span
                className="font-serif italic text-4xl md:text-5xl block"
                style={{ color: p.number }}
              >
                {p.n}
              </span>
              <h3
                className="font-serif text-3xl md:text-[2rem] lg:text-[2.35rem] tracking-tight leading-[1.04] mt-5 md:mt-6"
                style={{ color: p.heading }}
              >
                {p.title}
              </h3>
              <p
                className="mt-4 md:mt-5 text-sm lg:text-base leading-relaxed max-w-[34ch]"
                style={{ color: p.text }}
              >
                {p.body}
              </p>
            </div>
            {/* subtle iridescent corner sheen */}
            <span
              aria-hidden="true"
              className="absolute -bottom-16 -right-16 w-48 h-48 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none"
              style={{ background: `radial-gradient(circle, rgba(179,163,212,0.28) 0%, transparent 65%)` }}
            />
          </article>
        </Reveal>
      ))}
    </div>
  </section>
);
